import { Directive, ElementRef, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
var dw, dh, rw, rh, lx, ly;
@Directive({
  selector: '[easyzoom]'
})

export class EasyzoomDirective {
  private _el: HTMLElement;
  image: HTMLElement
  flyout: HTMLElement
  zoom: HTMLElement
  isOpen: boolean = false;
  isMouseOver: boolean = false;
  isReady: boolean = false;

  constructor(
    private el: ElementRef, private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._el = this.el.nativeElement;
      this._init();
    }
  }

  _init() {
    this.image = this._el.getElementsByTagName('img')[0];
    this.flyout = document.createElement('div');
    this.flyout.className = "easyzoom-flyout";
    this._el.addEventListener('mousemove', (e) => {
      this.zone.runOutsideAngular(() => {
        this._onMove(e);
      })
    });

    this._el.addEventListener('mouseleave', () => {
      this.zone.runOutsideAngular(() => {
        this._onLeave();
      })
    });

    this._el.addEventListener('mouseenter', (e) => {
      this.zone.runOutsideAngular(() => {
        this._onEnter(e)
      })
    });

    this._el.addEventListener('click', (e) => {
      this.zone.runOutsideAngular(() => {
        e.preventDefault();
      })
    });
  };

  _onMove(e) {
    if (!this.isOpen) return;
    e.preventDefault();
    this._move(e);
  };

  _move(e) {
    if (e.type.indexOf('touch') === 0) {
      var touchlist = e.touches;
      lx = touchlist[0].pageX;
      ly = touchlist[0].pageY;
    } else {
      lx = e.pageX || lx;
      ly = e.pageY || ly;
    }

    var pt = ly - this.offset(this._el).top;
    var pl = lx - this.offset(this._el).left;
    var xt = Math.ceil(pt * rh);
    var xl = Math.ceil(pl * rw);
    // Close if outside
    if (xl < 0 || xt < 0 || xl > dw || xt > dh) {
      this.hide();
    } else {
      var top = xt * -1;
      var left = xl * -1;
      this.zoom.style.top = top + 'px';
      this.zoom.style.left = left + 'px';
    }

  };

  hide() {
    if (!this.isOpen) return;
    this.flyout.parentElement.removeChild(this.flyout);
    this.isOpen = false;
  };

  _onEnter = function (e) {
    var touches = e.touches;

    this.isMouseOver = true;

    if (!touches || touches.length == 1) {
      e.preventDefault();
      this.show(e, true);
    }
  };

  show(e, testMouseOver) {
    var w1, h1, w2, h2;
    if (!this.isReady) {
      return this._loadImage(this.image.getAttribute("src"), () => {
        if (this.isMouseOver || !testMouseOver) {
          this.show(e, false);
        }
      });
    }

    this._el.appendChild(this.flyout);

    w1 = this._el.offsetWidth;
    h1 = this._el.offsetHeight;

    w2 = this.flyout.offsetWidth;
    h2 = this.flyout.offsetHeight;

    dw = this.zoom.offsetWidth - w2;
    dh = this.zoom.offsetHeight - h2;

    // For the case where the zoom image is actually smaller than
    // the flyout.
    if (dw < 0) dw = 0;
    if (dh < 0) dh = 0;

    rw = dw / w1;
    rh = dh / h1;

    this.isOpen = true;

    e && this._move(e);
  };

  _loadImage(href, callback) {
    this._el.className += " is-loading";
    this.zoom = document.createElement("img");
    this.zoom.setAttribute('src', href);
    this.zoom.style.position = 'absolute';
    this.zoom.onerror = () => {
      this._onError()
    };
    this.zoom.onload = (e) => {
      this._onLoad(e, callback)
    };
  };

  _onError() {
    this._el.classList.remove("is-loading");
    this._el.classList.add("is-error");
  };

  _onLoad(e, callback) {
    if (!e.currentTarget.width) return;
    this.isReady = true;
    this.flyout.innerHTML = "";
    this.flyout.appendChild(this.zoom);
    this._el.classList.remove("is-loading");
    this._el.classList.add("is-ready");
    callback();
  };

  _onLeave() {
    this.isMouseOver = false;
    this.isOpen && this.hide();
  };

  offset(obj) {
    var rect = obj.getBoundingClientRect();
    var win = obj.ownerDocument.defaultView;
    return {
      top: rect.top + win.pageYOffset,
      left: rect.left + win.pageXOffset
    };
  }

}